import { Gender as GenderType } from "../sdk/types"

type GenderName = "configuration_gender_female" | "configuration_gender_male" | "configuration_gender_divers" 

type Gender = {
    id: GenderType
    name: GenderName
    visibleInAddress: boolean
}

const genders: Gender[] = [
    {
        id: "female",
        name: "configuration_gender_female",
        visibleInAddress: true,
    },
    {
        id: "male",
        name: "configuration_gender_male",
        visibleInAddress: true,
    },
    {
        id: "divers",
        name: "configuration_gender_divers",
        visibleInAddress: false,
    },
]

export { genders }
